
import React from "react";
import { Grid, Typography,Paper,Box } from "@mui/material";
import AddIcon from '@mui/icons-material/Add'; // Replace with your image component or icon


const NoData = ({val}) => {
  return (
    <>
                  
                  <Paper elevation={3} sx={{ padding: 3, backgroundColor: '#ffffff', borderRadius: 2 }}>
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 3,
      border: '2px dashed #FF8C00',
      borderRadius: 2,
      minHeight: { xs: '200px', sm: '150px' },
      textAlign: 'center',
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Grid container alignItems="center" spacing={2}>
      <Grid
        item
        xs={12}
        sm={4}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: { xs: 2, sm: 0 },
        }}
      >
        <img 
          src="https://cdni.iconscout.com/illustration/premium/thumb/no-data-found-illustration-download-in-svg-png-gif-file-formats--office-computer-digital-work-business-pack-illustrations-7265556.png?f=webp" 
          alt="No Trade" 
          style={{ width: '80%', maxWidth: '120px', height: 'auto' }} 
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#FF8C00' }}>
          You don’t have any {val} yet!
        </Typography>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          sx={{ mt: 1, maxWidth: '500px', mx: 'auto' }}
        >
          Create your {val} to monitor your business journey effectively. With each transaction,
          gain seamless insights and maintain organized records for your growing trade activity.
        </Typography>
      </Grid>
    </Grid>
  </Box>
</Paper>


  </>
  
  
  );
};

export default NoData;
